// this is mixin for v-read directive
// if you will use it, provide emit update:<vread-from> to emits array for resolve warnings in console
export default {
  created() {
    const vread_from = this.$attrs['vread-from']

    if (vread_from && vread_from in this) {
      // track changes
      this.$watch(vread_from, (nval) => {
        this.$emit(`update:${vread_from}`, nval)
      })
      // pop up an initial val to the reader
      this.$emit(`update:${vread_from}`, this[vread_from])
    }
  }
}
